<template>

    <!--谈阔论swiper-->
    <div class="swiper-box">
        <swiper :options="swiperOption">
            <swiper-slide class="news-img" v-for="(item, index) in banner" :key="item.id">
                <a @click="goContent(item.id)">
                    <img class="logo" :src="item.logo" alt="Slide 1">
                    <div class="swiper-title-box">
                        <span class="swiper-title" v-text="item.title">3.15跨境网购侵害消费者权益问题线索</span>
                    </div>
                </a>
            </swiper-slide>
            <div class="pagination" slot="pagination"></div>
        </swiper>
    </div>
</template>

<script>
  import {swiper, swiperSlide} from 'vue-awesome-swiper'

  export default {
    name: "News-swiper",
    props: [
      'banner'
    ],
    data() {
      return {
        swiperOption: {
          pagination: {
            el: '.pagination',
            clickable: true,
          },
          autoplay: true,
          speed: 1000
        }
      }
    },
    methods: {
      goContent(id) {
        this.$router.push({path: 'article', query:{id: id}})
      },
    },
    components: {
      swiper,
      swiperSlide
    }
  }
</script>

<style scoped lang="less">
    .swiper-box {
        width: 380px;
        --height: 400px;

        .logo {
            width: 100%;
            height: var(--height);
        }

        .news-img {
            width: 100%;
            height: var(--height);
            position: relative;
        }

        .swiper-title-box {
            width: 460px;
            height: 40px;
            background: rgba(0, 0, 0, 0.9);
            position: absolute;
            bottom: 0;
            left: 0;
            opacity: .5;
        }

        .swiper-title {
            font-size: 16px;
            font-family: MicrosoftYaHei;
            color: rgba(255, 255, 255, 1);
            line-height: 40px;
            margin-left: 10px;
        }

        .pagination {
            position: absolute;
            left: 380px;
            z-index: 2;
        }
    }
</style>
